/**
 * Round names, shared by the fixtures screens.
 *
 * Knockouts can be a standard bracket, IPL-style playoffs (qualifier 1,
 * eliminator, qualifier 2, final) or cups by league position. A lower cup's
 * matches carry the cup's name in `group_name` ("Plate" → "Plate Final"); the
 * best cup's final is the tournament final. Keep in step with
 * backend/services/standings_rules.py (KNOCKOUT_ORDER).
 */
export const KNOCKOUT_ROUND_TYPES = [
  'round_of_32', 'round_of_16', 'quarter_final', 'qualifier_1', 'eliminator', 'qualifier_2',
  'semi_final', 'third_place', 'final',
];

const LONG = {
  league: 'League', group: 'Group Stage', round_of_32: 'Round of 32', round_of_16: 'Round of 16',
  quarter_final: 'Quarter Final', qualifier_1: 'Qualifier 1', eliminator: 'Eliminator',
  qualifier_2: 'Qualifier 2', semi_final: 'Semi Final', third_place: '3rd Place', final: 'Final',
};

const SHORT = {
  league: 'League', group: 'Group', round_of_32: 'R32', round_of_16: 'R16', quarter_final: 'QF',
  qualifier_1: 'Q1', eliminator: 'Elim', qualifier_2: 'Q2', semi_final: 'SF', third_place: '3rd', final: 'Final',
};

export const isKnockout = (roundType) => KNOCKOUT_ROUND_TYPES.includes(roundType);

/** "Qualifier 1", "Plate Final", "Group Stage" … for a fixture (or a round type). */
export function roundLabel(fixtureOrType, { short = false } = {}) {
  const fx = typeof fixtureOrType === 'string' ? { round_type: fixtureOrType } : (fixtureOrType || {});
  const names = short ? SHORT : LONG;
  const base = names[fx.round_type] || (fx.round_type || '').replace(/_/g, ' ');
  return isKnockout(fx.round_type) && fx.group_name ? `${fx.group_name} ${base}` : base;
}

/** The tournament's final (not a lower cup's). */
export const isTournamentFinal = (fx) => fx?.round_type === 'final' && !fx.group_name;
